import styled from "styled-components";

export const StyledEmojiSelector = styled.div`
  padding: 5px 0;
  width: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;

export const StyledEmojiWrapper = styled.div`
  display: flex;
  gap: 20px;
`;
export const StyledTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
